export enum Status {
  IDLE = 'IDLE',
  SHOW_PARSED_FILE_MODAL = 'SHOW_PARSED_FILE_MODAL',
  SHOW_ENTITY_MODAL_NEW = 'SHOW_ENTITY_MODAL_NEW',
  SHOW_ENTITY_MODAL_EDIT = 'SHOW_ENTITY_MODAL_EDIT',
  SHOW_FIELD_MODAL_NEW = 'SHOW_FIELD_MODAL_NEW',
  SHOW_FIELD_MODAL_EDIT = 'SHOW_FIELD_MODAL_EDIT',
}
